import { OfferDesignTypes } from 'views/OfferDesign/OfferDesign.types';

export enum OffersFilterKey {
  SEARCH = 'search',
  STATUSES = 'offerStatuses',
  SCHEDULES = 'offerSchedules',
  OFFER_DESIGN_IDS = 'offerDesignIds',
  CREATED_AT_FROM = 'createdAtFrom',
  CREATED_AT_UNTIL = 'createdAtUntil',
  PRICE_BUCKETS = 'priceBuckets'
}

export enum OfferStatusFilterValue {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}

export enum OfferScheduleType {
  PERMANENT = 'Permanent',
  INTERVAL = 'Interval'
}

export enum OfferPriceBucket {
  FREE = 'free',
  UP_TO_5 = 'upTo5',
  UP_TO_10 = 'upTo10',
  OVER_10 = 'over10'
}

export interface IOfferPriceBucketRange {
  min: number;
  max: number | null;
}

export interface IOffersFilterState {
  search: string;
  statuses: OfferStatusFilterValue[];
  schedules: OfferScheduleType[];
  offerDesignIds: string[];
  createdAtFrom: string;
  createdAtUntil: string;
  priceBuckets: OfferPriceBucket[];
}

export interface IOffersFilterBackendPayload {
  filterText?: string;
  active?: boolean;
  schedules?: OfferScheduleType[];
  offerDesignIds?: string[];
  createdAtFrom?: string;
  createdAtUntil?: string;
  priceMin?: number;
  priceMax?: number;
}

export enum OffersFilterId {
  SEARCH = 'search',
  STATUS = 'status',
  SCHEDULE = 'schedule',
  OFFER_DESIGN = 'offerDesign',
  CREATED_AT = 'createdAt',
  PRICE = 'price'
}

export interface IOffersFilterBarConfig {
  offerDesignType: OfferDesignTypes;
  hiddenFilters?: OffersFilterId[];
}
